/*
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-07-27 09:42:23
 * @LastEditors: AllezLRC 13636411941@163.com
 * @LastEditTime: 2025-03-27 14:27:30
 * @FilePath: /wemeet-admin-new/src/api/brand.js
 * @Description:
 * Copyright (c) 2023 by WeMeet, All Rights Reserved.
 */
import request from '@/utils/request'

/**
 * @description: 获取展会下展商列表
 * @param {*} data
 * @return {*}
 */
export function getBrandList(params) {
  return request({
    url: '/user/admin/exhibitor/query',
    method: 'GET',
    params,
  })
}

/**
 * @description: 新增展会下展商
 * @param {*} params
 * @return {*}
 */
export function addBrand(data) {
  return request({
    url: '/user/admin/exhibitor/add',
    method: 'POST',
    data,
  })
}

/**
 * @description: 修改展会下展商
 * @param {*} data
 * @return {*}
 */
export function editBrand(data) {
  return request({
    url: '/user/admin/exhibitor/update',
    method: 'POST',
    data,
  })
}

/**
 * @description: 修改展会展商上下架状态
 * @param {*} data
 * @return {*}
 */
export function editBrandStatus(data) {
  return request({
    url: '/user/admin/exhibitor/update/status',
    method: 'POST',
    data,
  })
}

/**
 * @description: 查询展商详情
 * @param {*} data
 * @return {*}
 */
export function getBrandDetail(params) {
  return request({
    url: '/user/admin/exhibitor/query/detail',
    method: 'GET',
    params,
  })
}

/**
 * @description: 获取展商下展品列表
 * @param {*} params
 * @return {*}
 */
export function getBrandProductList(params) {
  return request({
    url: '/user/admin/exhibit/query',
    method: 'GET',
    params,
  })
}

/**
 * @description: 新增展商下展品
 * @param {*} data
 * @return {*}
 */
export function addBrandProduct(data) {
  return request({
    url: '/user/admin/exhibit/add',
    method: 'POST',
    data,
  })
}
/**
 * @description: 编辑展商下展品
 * @param {*} data
 * @return {*}
 */
export function editBrandProduct(data) {
  return request({
    url: '/user/admin/exhibit/update',
    method: 'POST',
    data,
  })
}
/**
 * @description: 编辑展商下展品排序
 * @param {*} data
 * @return {*}
 */
export function editBrandProductSort(data) {
  return request({
    url: '/user/admin/exhibit/update/sort',
    method: 'POST',
    data,
  })
}

/**
 * @description: 获取展商下展品详情
 * @param {*} data
 * @return {*}
 */
export function getBrandProductDetail(params) {
  return request({
    url: '/user/admin/exhibit/query/detail',
    method: 'get',
    params,
  })
}
/**
 * @description: 修改展商下展品状态
 * @param {*} data
 * @return {*}
 */
export function editBrandProductStatus(data) {
  return request({
    url: '/user/admin/exhibit/updateStatus',
    method: 'POST',
    data,
  })
}

/**
 * @description: 获取展会下所有展品列表
 * @param {*} data
 * @return {*}
 */
export function getAllProductList(params) {
  return request({
    url: '/user/admin/exhibit/query/all',
    method: 'GET',
    params,
  })
}

/**
 * @description: 获取认证企业列表
 * @return {*} params
 */
export function getAllEnterpriseList(params) {
  return request({
    url: '/user/enterprise/getEnterpriseByName',
    method: 'GET',
    params,
  })
}
/**
 * @description: 获取企业详情
 * @param {*} params
 * @return {*}
 */
export function getAllEnterpriseDetail(params) {
  return request({
    url: '/user/enterprise/homepage',
    method: 'GET',
    params,
  })
}

/**
 * @description: 获取机构下展品列表
 * @param {*} params
 * @return {*}
 */
export function getAllEnterpriseProduct(params) {
  return request({
    url: '/user/enterprise/product/queryList',
    method: 'GET',
    params,
  })
}
/**
 * @description: 展商同步机构下展品
 * @param {*} params
 * @return {*}
 */
export function syncEnterpriseProduct(data) {
  return request({
    url: '/user/admin/exhibit/sync',
    method: 'POST',
    data,
  })
}

/**
 * @description: 查询展品属性/分类
 * @param {*} params
 * @return {*}
 */
export function queryProductAttribute(params) {
  return request({
    url: '/user/admin/exhibit/queryProductAttribute',
    method: 'GET',
    params,
  })
}
/**
 * @description: 新增展品属性/分类
 * @param {*} params
 * @return {*}
 */
export function addProductAttribute(data) {
  return request({
    url: '/user/admin/exhibit/addProductAttribute',
    method: 'POST',
    data,
  })
}

/**
 * @description: 编辑展品属性/分类
 * @param {*} params
 * @return {*}
 */
export function editProductAttribute(data) {
  return request({
    url: '/user/admin/exhibit/updateProductAttribute',
    method: 'POST',
    data,
  })
}

/**
 * @description: 删除展商
 * @param {*} params
 * @return {*}
 */
export function deleteBrand(params) {
  return request({
    url: '/user/admin/exhibitor/delete',
    method: 'GET',
    params,
  })
}

/**
 * @description: 删除展品
 * @param {*} params
 * @return {*}
 */
export function deleteProduct(params) {
  return request({
    url: '/user/admin/exhibit/delete',
    method: 'GET',
    params,
  })
}

/**
 * @description: 导入展商
 * @param {*} params
 * @return {*}
 */
export function importBrand(data, meetingCode) {
  return request({
    url: `/user/admin/exhibitor/import?meetingCode=${meetingCode}`,
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

/**
 * @description: 导入展商结果列表
 * @param {*} params
 * @return {*}
 */
export function importBrandResult(params) {
  return request({
    url: `/user/admin/exhibitor/import/errorDataList`,
    method: 'GET',
    params,
  })
}

/**
 * @description: 导出展商导入结果
 * @param {*} params
 * @return {*}
 */
export function _exportErrorData(params) {
  return request({
    url: `/user/admin/exhibitor/export/errorDataList`,
    method: 'GET',
    params,
  })
}

/**
 * @description: 导入展品
 * @param {*} params
 * @return {*}
 */
export function importBrandProduct(data, exhibitorCode) {
  return request({
    url: `/user/admin/exhibit/import?exhibitorCode=${exhibitorCode}`,
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

/**
 * @description: 批量导入展品
 * @param {*} params
 * @return {*}
 */
export function importProduct(data, meetingCode) {
  return request({
    url: `/user/admin/exhibit/importByExhibitorName?meetingCode=${meetingCode}`,
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

/**
 * @description: 导入展品结果列表
 * @param {*} params
 * @return {*}
 */
export function importBrandProductResult(params) {
  return request({
    url: `/user/admin/exhibit/import/errorDataList`,
    method: 'GET',
    params,
  })
}

/**
 * @description: 导出展品导入结果
 * @param {*} params
 * @return {*}
 */
export function _exportErrorDataByProduct(params) {
  return request({
    url: `/user/admin/exhibit/export/errorDataList`,
    method: 'GET',
    params,
  })
}

/**
 * @description: 新建展商展品生成虚拟 code
 * @param {*} params
 * @return {*}
 */
export function generateNotRealCode(params) {
  return request({
    url: `/user/enterprise/product/generateCode`,
    method: 'GET',
    params,
  })
}

/**
 * @description: 展商展品联系人同步
 * @param {*} params
 * @return {*}
 */
export function queryContactInfoLibrary(params) {
  return request({
    url: `/user/enterprise/queryContactInfoLibrary`,
    method: 'GET',
    params,
  })
}
/**
 * @description: 根据场景查询联系人
 * @param {*} params
 * @return {*}
 */
export function queryContactInfoByType(params) {
  return request({
    url: `/user/enterprise/queryContactInfoByType`,
    method: 'GET',
    params,
  })
}

/**
 * @description: 批量保存联系人信息
 * @param {*} params
 * @return {*}
 */
export function addBatchContactInfo(data) {
  return request({
    url: `/user/enterprise/addBatchContactInfo`,
    method: 'POST',
    data,
  })
}

/**
 * @description: 更新联系人信息
 * @param {*} params
 * @return {*}
 */
export function updateContactInfo(data) {
  return request({
    url: `/user/enterprise/updateContactInfo`,
    method: 'POST',
    data,
  })
}

/**
 * @description: 添加联系人信息
 * @param {*} params
 * @return {*}
 */
export function addContactInfo(data) {
  return request({
    url: `/user/enterprise/addContactInfo`,
    method: 'POST',
    data,
  })
}

// 展商批量上下架
export function batchUpDateExhibitor(data) {
  return request({
    url: `/user/admin/exhibitor/batchUpdate/status`,
    method: 'POST',
    data,
  })
}

// 展品批量上下架
export function batchUpDateExhibiti(data) {
  return request({
    url: `/user/admin/exhibit/batchUpdateStatus`,
    method: 'POST',
    data,
  })
}

// 查询展商特化字段行业类型
export function queryIndustryTypeExhibitor(data) {
  return request({
    url: `/user/admin/exhibitor/queryIndustryType`,
    method: 'POST',
    data,
  })
}

// 查询所有国家信息
export function countryQueryInfo() {
  return request({
    url: `/user/country/queryInfo`,
    method: 'GET',
  })
}

// 查询产品的行业字段
export function queryProductIndustry(params) {
  return request({
    url: `/user/admin/exhibit/queryProductIndustry`,
    method: 'GET',
    params,
  })
}

// 新增产品的行业字段
export function addProductIndustry(data) {
  return request({
    url: `/user/admin/exhibit/addProductIndustry`,
    method: 'POST',
    data,
  })
}
// 修改产品的行业字段
export function updateProductIndustry(data) {
  return request({
    url: `/user/admin/exhibit/updateProductIndustry`,
    method: 'POST',
    data,
  })
}
// 修改产品的行业字段
export function queryExpansionTypeList(params) {
  return request({
    url: `/user/enterprise/queryExpansionTypeList`,
    method: 'GET',
    params,
  })
}

// 批量更新机构荟客厅
export function exhibitorSyncErToEn(data) {
  return request({
    url: `/user/admin/exhibitor/syncErToEn`,
    method: 'POST',
    data,
  })
}

// 批量更新机构荟客厅下产品
export function syncExibitToProduct(data) {
  return request({
    url: `/user/admin/exhibitor/syncExibitToProduct`,
    method: 'POST',
    data,
  })
}

// 展商海报下载
export function downloadPoster(params) {
  return request({
    url: `/user/admin/exhibitor/downloadPoster`,
    method: 'GET',
    params,
  })
}
